import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Box,
    Card,
    Button,
    makeStyles,
    Container,
    Divider,
    CardContent,
    CardHeader,
    Grid,
    TextField,
    MenuItem,
    InputLabel
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import authService from '../../../../utils/permissionAuth';
import tokenService from '../../../../utils/tokenDecoder';
import { trackPromise } from 'react-promise-tracker';
import * as Yup from "yup";
import { LoadingComponent } from 'src/utils/newLoader';
import { Formik } from 'formik';
import { useAlert } from "react-alert";
import xlsx from 'json-as-xlsx';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import moment from 'moment';
import 'date-fns';

const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.dark,
        minHeight: '100%',
        paddingBottom: theme.spacing(3),
        paddingTop: theme.spacing(3)
    },
    avatar: {
        marginRight: theme.spacing(2)
    },
    colorCancel: {
        backgroundColor: "red",
    },
    colorRecordAndNew: {
        backgroundColor: "#FFBE00"
    },
    colorRecord: {
        backgroundColor: "green",
    }
}));

const getPreviousMonth = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();
    let previousMonth = month === 0 ? 11 : month - 1;
    let previousYear = month === 0 ? year - 1 : year;
    const formattedMonth = String(previousMonth + 1).padStart(2, '0');

    return `${previousYear}-${formattedMonth}`;
};

const screenCode = 'SUPPLYDEBTLISTREPORT2';

export default function SupplyDebtListReport(props) {
    const [title, setTitle] = useState("Supply Debt List Report 2")
    const classes = useStyles();
    const [groups, setGroups] = useState();
    const [factories, setFactories] = useState();
    const [routes, setRoutes] = useState();
    const [supplyDebtInput, setSupplyDebtInput] = useState({
        groupID: '0',
        factoryID: '0',
        routeID: '0',
        month: getPreviousMonth(),
    })
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const navigate = useNavigate();
    const alert = useAlert();
    const [supplyDebtDetails, setSupplyDebtDetails] = useState([]);
    const [selectedSearchValues, setSelectedSearchValues] = useState({
        groupName: "0",
        factoryName: "0",
        routeName: "All Routes"
    })
    const [csvHeaders, SetCsvHeaders] = useState([])
    const componentRef = useRef();

    const [limit, setLimit] = useState(5);
    const [page, setPage] = useState(0);
    const [totalBalance, setTotalBalance] = useState(0);

    const handleLimitChange = (event) => {
        setLimit(event.target.value);
    };

    const handlePageChange = (event, newPage) => {
        setPage(newPage);
    };

    useEffect(() => {
        trackPromise(getGroupsForDropdown(), getPermission());
    }, []);

    useEffect(() => {
        trackPromise(getFactoriesForDropDown());
    }, [supplyDebtInput.groupID]);

    useEffect(() => {
        trackPromise(
            getRoutesByFactoryID()
        )
    }, [supplyDebtInput.factoryID]);

    useEffect(() => {
        if (supplyDebtInput.groupID !== '0' && supplyDebtInput.factoryID !== '0') {
            trackPromise(getLatestApplicableDate());
        }
    }, [supplyDebtInput.groupID, supplyDebtInput.factoryID]);

    async function getPermission() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWSUPPLYDEBTLISTREPORT2');

        if (isAuthorized === undefined) {
            navigate('/404');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined
        });

        const groupID = parseInt(tokenService.getGroupIDFromToken());
        const factoryID = parseInt(tokenService.getFactoryIDFromToken());

        setSupplyDebtInput(prev => ({
            ...prev,
            groupID: groupID,
            factoryID: factoryID
        }));
    }

    async function getLatestApplicableDate() {
        try {
            const response = await services.GetLatestApplicableDate(
                parseInt(supplyDebtInput.groupID),
                parseInt(supplyDebtInput.factoryID)
            );
            if (response.statusCode === "Success") {
                const latestDate = response.data;
                const formattedMonth = `${latestDate.applicableYear}-${String(latestDate.applicableMonth).padStart(2, '0')}`;
                setSupplyDebtInput(prev => ({
                    ...prev,
                    month: formattedMonth
                }));
            }
        } catch (error) {
            console.error('Error fetching latest applicable date:', error);
        }
    }

    async function getGroupsForDropdown() {
        const groups = await services.getAllGroups();
        setGroups(groups);
    }
    async function getFactoriesForDropDown() {
        const factory = await services.getFactoryByGroupID(supplyDebtInput.groupID);
        setFactories(factory);
    }

    async function getRoutesByFactoryID() {
        const route = await services.getRoutesForDropDown(supplyDebtInput.factoryID);
        setRoutes(route);
    }

    async function GetDetails() {
        getSelectedDropdownValuesForReport(supplyDebtInput.groupID, supplyDebtInput.factoryID, supplyDebtInput.routeID, supplyDebtInput.month);
        const supplyDebtData = await services.GetSupplyDebtListDetails(supplyDebtInput.groupID, supplyDebtInput.factoryID, supplyDebtInput.routeID, supplyDebtInput.month);
        const filteredData = supplyDebtData.data.filter(item => item.thisMonthCropWeight > 0);
        if (supplyDebtData.statusCode == "Success" && supplyDebtData.data != null) {
            const groupedData = groupDataByRoute(filteredData);
            setSupplyDebtDetails(groupedData);
            calculateTotalBalance(groupedData);
            if (filteredData.length == 0) {
                alert.error("No records to display");
            }
        }
        else {
            alert.error("No records to display");
        }
    }

    async function createDataForExcel(array) {
        let res = [];

        if (array && array.length > 0) {
            array.forEach(group => {
                group.records.forEach(rec => {
                    res.push({
                        'Route': group.routeName,
                        'Registration Number': rec.registrationNumber,
                        'Customer Name': rec.name,
                        'Last Month Crop (KG)': rec.lastMonthCropWeight,
                        'This Month Crop (KG)': rec.thisMonthCropWeight,
                        'Loan Balance (Rs.)': parseFloat(rec.loanTotal),
                        'Last Month Debt (Rs.)': parseFloat(rec.debtAmount),
                        'Last Month Balance (Rs.)': parseFloat(rec.lastMonthBalance),
                        'This Month Balance (Rs.)': parseFloat(rec.balance)
                    });
                });

                res.push({
                    'Route': '',
                    'Registration Number': '',
                    'Customer Name': '',
                    'Last Month Crop (KG)': '',
                    'This Month Crop (KG)': '',
                    'Loan Balance (Rs.)': '',
                    'Last Month Debt (Rs.)': '',
                    'Last Month Balance (Rs.)': '',
                    'This Month Balance (Rs.)': ''
                });

                res.push({
                    'Route': `Route Total: (${group.records.length})`,
                    'Registration Number': '',
                    'Customer Name': '',
                    'Last Month Crop (KG)': '',
                    'This Month Crop (KG)': '',
                    'Last Month Balance (Rs.)': '',
                    'This Month Balance (Rs.)': parseFloat(group.totalBalance)
                });

                res.push({
                    'Route': '',
                    'Registration Number': '',
                    'Customer Name': '',
                    'Last Month Crop (KG)': '',
                    'This Month Crop (KG)': '',
                    'Loan Balance (Rs.)': '',
                    'Last Month Debt (Rs.)': '',
                    'Last Month Balance (Rs.)': '',
                    'This Month Balance (Rs.)': ''
                });
            });

            if (array.length > 1) {
                res.push({
                    'Route': 'Grand Total:',
                    'Registration Number': '',
                    'Customer Name': '',
                    'Last Month Crop (KG)': '',
                    'This Month Crop (KG)': '',
                    'Loan Balance (Rs.)': '',
                    'Last Month Debt (Rs.)': '',
                    'Last Month Balance (Rs.)': '',
                    'This Month Balance (Rs.)': parseFloat(totalBalance)
                });
            }

            res.push({
                'Route': '',
                'Registration Number': '',
                'Customer Name': '',
                'Last Month Crop (KG)': '',
                'This Month Crop (KG)': '',
                'Loan Balance (Rs.)': '',
                'Last Month Debt (Rs.)': '',
                'Last Month Balance (Rs.)': '',
                'This Month Balance (Rs.)': ''
            });

            const allRoutes = array.map(group => group.routeName);
            const routeDisplay = allRoutes.length === 1 ? allRoutes[0] : 'All Routes';

            res.push({
                'Route': `Group: ${selectedSearchValues.groupName}`,
                'Registration Number': `Factory: ${selectedSearchValues.factoryName}`,
                'Customer Name': '',
                'Last Month Crop (KG)': '',
                'This Month Crop (KG)': '',
                'Loan Balance (Rs.)': '',
                'Last Month Debt (Rs.)': '',
                'Last Month Balance (Rs.)': '',
                'This Month Balance (Rs.)': ''
            });

            res.push({
                'Route': `Route: ${routeDisplay}`,
                'Registration Number': `Month: ${selectedSearchValues.month}`,
                'Customer Name': '',
                'Last Month Crop (KG)': '',
                'This Month Crop (KG)': '',
                'Loan Balance (Rs.)': '',
                'Last Month Debt (Rs.)': '',
                'Last Month Balance (Rs.)': '',
                'This Month Balance (Rs.)': ''
            });
        }

        return res;
    }

    async function createFile() {
        var file = await createDataForExcel(supplyDebtDetails);
        var settings = {
            sheetName: 'Supply Debt List Report 2',
            fileName: 'Supply Debt List Report 2' + selectedSearchValues.groupName + ' - ' + selectedSearchValues.factoryName,
            writeOptions: {}
        }

        let keys = Object.keys(file[0])
        let tempcsvHeaders = csvHeaders;
        keys.map((sitem, i) => {
            tempcsvHeaders.push({ label: sitem, value: sitem })
        })

        let dataA = [
            {
                sheet: 'Supply Debt List Report 2',
                columns: tempcsvHeaders,
                content: file
            }
        ]
        xlsx(dataA, settings);
    }

    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function getSelectedDropdownValuesForReport(groupID, factoryID, routeID, month) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            groupName: groups[groupID],
            factoryName: factories[factoryID],
            routeName: routeID === '0' ? 'All Routes' : routes[routeID],
            month: moment(month).format('MMMM - YYYY')
        })
    }

    function cardTitle(titleName) {
        return (
            <Grid container spacing={1}>
                <Grid item md={10} xs={12}>
                    {titleName}
                </Grid>
            </Grid>
        )
    }

    function handleChange(e) {
        const target = e.target;
        const value = target.value
        setSupplyDebtInput({
            ...supplyDebtInput,
            [e.target.name]: value
        });
        setSupplyDebtDetails([]);
    }

    function groupDataByRoute(data) {
        const grouped = {};

        data.forEach(item => {
            const routeName = item.routeName;
            if (!grouped[routeName]) {
                grouped[routeName] = {
                    routeName: routeName,
                    records: [],
                    totalBalance: 0,
                    totalDebtAmount: 0,
                    totalLoanBalance: 0
                };
            }
            grouped[routeName].records.push(item);
            grouped[routeName].totalBalance += parseFloat(item.balance) || 0;
            grouped[routeName].totalDebtAmount += parseFloat(item.debtAmount) || 0;
            grouped[routeName].totalLoanBalance += parseFloat(item.loanTotal) || 0;
        });

        return Object.values(grouped);
    }

    function calculateTotalBalance(data) {
        const total = data.reduce((acc, group) => acc + (parseFloat(group.totalBalance) || 0), 0);
        setTotalBalance(total);
    }

    return (
        <Fragment>
            <LoadingComponent />
            <Page className={classes.root} title={title}>
                <Container maxWidth={false}>
                    <Formik
                        initialValues={{
                            groupID: supplyDebtInput.groupID,
                            factoryID: supplyDebtInput.factoryID
                        }}
                        validationSchema={
                            Yup.object().shape({
                                groupID: Yup.number().required('Group is required').min("1", 'Group is required'),
                                factoryID: Yup.number().required('Factory is required').min("1", 'Factory is required')
                            })
                        }
                        onSubmit={() => trackPromise(GetDetails())}
                        enableReinitialize
                    >
                        {({
                            errors,
                            handleBlur,
                            handleSubmit,
                            touched
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Box mt={0}>
                                    <Card>
                                        <CardHeader
                                            title={cardTitle(title)}
                                        />
                                        <PerfectScrollbar>
                                            <Divider />
                                            <CardContent>
                                                <Grid container spacing={3}>
                                                    <Grid item md={3} xs={8}>
                                                        <InputLabel shrink id="groupID">
                                                            Group *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.groupID && errors.groupID)}
                                                            fullWidth
                                                            helperText={touched.groupID && errors.groupID}
                                                            name="groupID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={supplyDebtInput.groupID}
                                                            variant="outlined"
                                                            id="groupID"
                                                            size='small'
                                                            disabled={!permissionList.isGroupFilterEnabled}
                                                        >
                                                            <MenuItem value="0">--Select Group--</MenuItem>
                                                            {generateDropDownMenu(groups)}
                                                        </TextField>
                                                    </Grid>

                                                    <Grid item md={3} xs={8}>
                                                        <InputLabel shrink id="factoryID">
                                                            Factory *
                                                        </InputLabel>
                                                        <TextField select
                                                            error={Boolean(touched.factoryID && errors.factoryID)}
                                                            fullWidth
                                                            helperText={touched.factoryID && errors.factoryID}
                                                            name="factoryID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={supplyDebtInput.factoryID}
                                                            variant="outlined"
                                                            id="factoryID"
                                                            disabled={!permissionList.isFactoryFilterEnabled}
                                                            size='small'
                                                        >
                                                            <MenuItem value="0">--Select Factory--</MenuItem>
                                                            {generateDropDownMenu(factories)}
                                                        </TextField>
                                                    </Grid>

                                                    <Grid item md={3} xs={8}>
                                                        <InputLabel shrink id="routeID">
                                                            Route
                                                        </InputLabel>
                                                        <TextField select
                                                            fullWidth
                                                            name="routeID"
                                                            onBlur={handleBlur}
                                                            onChange={(e) => handleChange(e)}
                                                            value={supplyDebtInput.routeID}
                                                            variant="outlined"
                                                            id="routeID"
                                                            size='small'
                                                        >
                                                            <MenuItem value="0">--Select Routes--</MenuItem>
                                                            {generateDropDownMenu(routes)}
                                                        </TextField>
                                                    </Grid>

                                                    <Grid item md={3} xs={8}>
                                                        <InputLabel shrink id="month">
                                                            Month *
                                                        </InputLabel>
                                                        <TextField
                                                            error={Boolean(touched.date && errors.date)}
                                                            fullWidth
                                                            helperText={touched.date && errors.date}
                                                            size='small'
                                                            name="month"
                                                            type="month"
                                                            onChange={(e) => handleChange(e)}
                                                            value={supplyDebtInput.month}
                                                            variant="outlined"
                                                            id="month"
                                                            inputProps={{
                                                                max: new Date().toISOString().slice(0, 7)
                                                            }}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <br />
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        type="submit"
                                                        variant="contained"
                                                        size='small'
                                                    >
                                                        Search
                                                    </Button>
                                                </Box>

                                                <Box minWidth={1050}>
                                                    {supplyDebtDetails.length > 0 ?
                                                        <Box display="flex" justifyContent="flex-end" p={2}>
                                                            <TableContainer component={Paper}>
                                                                <Table>
                                                                    <TableHead>
                                                                        <TableRow>
                                                                            <TableCell align="center" style={{ border: "1px solid black", width: '150px' }}>Registration Number</TableCell>
                                                                            <TableCell align="center" style={{ border: "1px solid black", width: '200px' }}>Customer Name</TableCell>
                                                                            <TableCell align="center" style={{ border: "1px solid black", width: '150px' }}>Last Month Crop (KG)</TableCell>
                                                                            <TableCell align="center" style={{ border: "1px solid black", width: '150px' }}>This Month Crop (KG)</TableCell>
                                                                            <TableCell align="center" style={{ border: "1px solid black", width: '150px' }}>Loan Balance (Rs.)</TableCell>
                                                                            <TableCell align="center" style={{ border: "1px solid black", width: '150px' }}>Last Month Debt (Rs.)</TableCell>
                                                                            <TableCell align="center" style={{ border: "1px solid black", width: '150px' }}>Last Month Balance (Rs.)</TableCell>
                                                                            <TableCell align="center" style={{ border: "1px solid black", width: '150px' }}>This Month Balance (Rs.)</TableCell>
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody>
                                                                        {supplyDebtDetails.slice(page * limit, page * limit + limit).map((group, index) => (
                                                                            <React.Fragment key={index}>
                                                                                <TableRow>
                                                                                    <TableCell colSpan={8} align="center" style={{ backgroundColor: "#B0C4DE", fontWeight: "bold", border: "1px solid black" }}>
                                                                                        {group.routeName}
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                                {group.records.map((rec, idx) => (
                                                                                    <TableRow key={`${index}-${idx}`}>
                                                                                        <TableCell style={{ border: "1px solid black" }}>{rec.registrationNumber}</TableCell>
                                                                                        <TableCell style={{ border: "1px solid black" }}>{rec.name}</TableCell>
                                                                                        <TableCell align="right" style={{ border: "1px solid black" }}>{rec.lastMonthCropWeight.toFixed(2)}</TableCell>
                                                                                        <TableCell align="right" style={{ border: "1px solid black" }}>{rec.thisMonthCropWeight.toFixed(2)}</TableCell>
                                                                                        <TableCell align="right" style={{ border: "1px solid black" }}>{rec.loanTotal.toFixed(2)}</TableCell>
                                                                                        <TableCell align="right" style={{ border: "1px solid black" }}>{rec.debtAmount.toFixed(2)}</TableCell>
                                                                                        <TableCell align="right" style={{ border: "1px solid black" }}>{rec.lastMonthBalance.toFixed(2)}</TableCell>
                                                                                        <TableCell align="right" style={{ border: "1px solid black" }}>{rec.balance.toFixed(2)}</TableCell>
                                                                                    </TableRow>
                                                                                ))}
                                                                                <TableRow>
                                                                                    <TableCell colSpan={7} align="left" style={{ border: "1px solid black" }}><b>Route Total: ({group.records.length})</b></TableCell>
                                                                                    <TableCell align="right" style={{ border: "1px solid black" }}><b>{group.totalBalance.toFixed(2)}</b></TableCell>
                                                                                </TableRow>
                                                                            </React.Fragment>
                                                                        ))}
                                                                        {supplyDebtDetails.length > 1 && (
                                                                            <TableRow>
                                                                                <TableCell colSpan={7} align="left" style={{ border: "1px solid black" }}><b>Grand Total:</b></TableCell>
                                                                                <TableCell align="right" style={{ border: "1px solid black" }}><b>{totalBalance.toFixed(2)}</b></TableCell>
                                                                            </TableRow>
                                                                        )}
                                                                    </TableBody>
                                                                </Table>
                                                                <TablePagination
                                                                    component="div"
                                                                    count={supplyDebtDetails.length}
                                                                    page={page}
                                                                    onChangePage={handlePageChange}
                                                                    rowsPerPage={limit}
                                                                    onChangeRowsPerPage={handleLimitChange}
                                                                    rowsPerPageOptions={[5, 10, 25, 50]}
                                                                />
                                                            </TableContainer>
                                                        </Box>
                                                        : null}
                                                </Box>

                                            </CardContent>
                                            {supplyDebtDetails.length > 0 ?
                                                <Box display="flex" justifyContent="flex-end" p={2}>
                                                    <Button
                                                        color="primary"
                                                        id="btnRecord"
                                                        type="submit"
                                                        variant="contained"
                                                        style={{ marginRight: '1rem' }}
                                                        className={classes.colorRecord}
                                                        onClick={createFile}
                                                        size='small'
                                                    >
                                                        EXCEL
                                                    </Button>
                                                    <div>&nbsp;</div>
                                                    <ReactToPrint
                                                        trigger={() => <Button
                                                            color="primary"
                                                            id="btnCancel"
                                                            variant="contained"
                                                            style={{ marginRight: '1rem' }}
                                                            className={classes.colorCancel}
                                                            size='small'
                                                        >
                                                            PDF
                                                        </Button>}
                                                        content={() => componentRef.current}
                                                        documentTitle={`Supply Debt List Report 2 - ${selectedSearchValues.groupName} - ${selectedSearchValues.factoryName} - ${selectedSearchValues.month}`}
                                                        pageStyle={`
                                                            @page {
                                                            size: A4;
                                                            margin: 0.5in;
                                                            }
                                                            @media print {
                                                            body { 
                                                            background-color: white !important;
                                                            -webkit-print-color-adjust: exact;
                                                            }
                                                            }
                                                            `}
                                                    />
                                                    <div hidden={true}>
                                                        <CreatePDF ref={componentRef} SupplyDebtInput={supplyDebtInput} SupplyDebtDetails={supplyDebtDetails}
                                                            SearchData={selectedSearchValues} />
                                                    </div>
                                                </Box> : null}
                                        </PerfectScrollbar>
                                    </Card>
                                </Box>
                            </form>
                        )}
                    </Formik>
                </Container>
            </Page>
        </Fragment>
    )
}

